<template>
    <label v-if="label">{{ label }}:</label>
    <div class="BaseFileInput">
        <input
                v-bind="$attrs"
                type="file"
                @change="inputChanged"
                ref="input"
        >
        <div class="BaseFileInput-input" @click="$refs.input.click()">
            <span>{{inputText}}</span>
        </div>
        <BaseButton v-if="!isFileSelected" type="button" @click="$refs.input.click()" class="BaseFileInput-button">Vybrat soubor</BaseButton>
        <BaseButton v-else type="button" @click="resetInput" class="BaseFileInput-button">Odstranit</BaseButton>
    </div>
</template>

<script>
import {ref, computed, onMounted} from 'vue';

export default {
    name: 'BaseFileInput',
    props: {
        label: String,
        file: File
    },
    setup(_, {emit}) {
    	const initText = 'Maximální velikost souboru 5 MB';
        const input = ref(null);
        const inputText = ref(initText);
        const isFileSelected = computed(() => {return _.file !== null });

        const renderBasedOnFile = file => {
            inputText.value = file && isFileSelected ? file.name : initText;
        }

        const inputChanged = event => {
            input.value = event.target;
            if (input.value.value) {
                _.file = input.value.files[0];
            } else {
                emit('resetInput');
            }

            renderBasedOnFile(_.file);
        }

        const resetInput = () => {
            _.file = null;
            input.value.value = '';
            inputText.value = initText;
            emit('resetInput');
        }

        onMounted(() => {
            renderBasedOnFile(_.file);
        })

        return {
            inputChanged,
            resetInput,
            inputText,
            isFileSelected,
            input
        }
    }
}
</script>

<style lang="scss" scoped>
    label {
        display: block;
        font-weight: 700;
        margin-bottom: .3em;
        font-size: .9em;
    }

    .BaseFileInput {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        max-width: 30rem;

        input {
            display: none;
        }

        &-input {
            display: flex;
            align-items: center;
            flex: 1;
            padding: .5em 1em;
            outline: 0;
            border: 2px solid var(--colorInputBorder);
            margin-right: 1em;
            font-size: .8em;
            @media(max-width: 500px) {
                max-width: 100%;
                margin-right: 0;
            }

            span {
                max-width: 100%;
                display: block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        &-button {
            font-size: .8em;
            padding: .5em 1em;
            @media(max-width: 500px) {
                width: 100%;
                margin-top: .5em;
                text-align: center;
                justify-content: center;
            }
        }
    }


</style>
